import { SET_PAGE } from '../constants/index'
import { setPageType } from '../types/pageListenerTypes'

export const setPageAction = (payload: setPageType) => {
  return {
    type: SET_PAGE,
    payload
  }
}

